module.exports = __webpack_public_path__ + "img/200291578.36d37df5.jpg";